import { STATUS_CLASS_CONFIG } from '@/config/httpStatus';
import type { StatusClass } from '@/types/stats';
import './stats.css';

export interface StatusClassLegendProps {
  classes: readonly StatusClass[];
}

/**
 * Swatch + label for each status class shown in a chart
 */
export function StatusClassLegend({ classes }: StatusClassLegendProps) {
  return (
    <ul className="status-legend" aria-label="Legend">
      {classes.map((cls) => (
        <li key={cls} className="status-legend-item">
          <span className={`status-legend-swatch ${STATUS_CLASS_CONFIG[cls].className}`} aria-hidden="true" />
          {STATUS_CLASS_CONFIG[cls].label}
        </li>
      ))}
    </ul>
  );
}
